export default "__VITE_ASSET__82a46a20__"